import React, {createContext, useState} from 'react';
import {useHistory, useParams} from "react-router";
import {Basic} from './Basic'

export const Context = createContext({})

export const Details = () => {
    const params = useParams();
    const history = useHistory();

    const [section_id, setSectionId] = useState(0);

    return (
        <React.Fragment>
            <a href={"#"} onClick={history.goBack}>Voltar para lista</a>
            <Context.Provider value={{course_id: params.id, section_id, setSectionId}}>
                <Basic/>
            </Context.Provider>
        </React.Fragment>
    );
}